import { render, staticRenderFns } from "./Register-departamento.vue?vue&type=template&id=69017ab3&"
import script from "./Register-departamento.vue?vue&type=script&lang=js&"
export * from "./Register-departamento.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports